// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__Re-MI","footer":"ChangeClinic_footer__39Q-x"};